import { gql } from '@apollo/client';

// 모든 관리자 목록 조회
export const GET_ALL_ADMINS = gql`
  query GetAllAdmins {
    getAllAdmins {
      id
      name
      email
      mobile
      phone
      department
      company
      role
      createdAt
      lastLoginAt
    }
  }
`;

// 특정 관리자 정보 조회
export const GET_ADMIN_BY_ID = gql`
  query GetAdminById($id: ID!) {
    getAdminById(id: $id) {
      id
      name
      email
      mobile
      phone
      department
      company
      role
      createdAt
      lastLoginAt
    }
  }
`;

// 관리자 프로필 수정
export const UPDATE_ADMIN_PROFILE = gql`
  mutation UpdateAdminProfile($input: UpdateAdminProfileInput!) {
    updateAdminProfile(input: $input) {
      success
      message
      user {
        id
        name
        email
        mobile
        phone
        department
        company
        role
      }
    }
  }
`;

// 관리자 생성
export const CREATE_ADMIN = gql`
  mutation CreateAdmin($input: CreateAdminInput!) {
    createAdmin(input: $input) {
      success
      message
      user {
        id
        name
        email
        mobile
        phone
        department
        company
        role
      }
    }
  }
`;

// 관리자 삭제
export const DELETE_ADMIN = gql`
  mutation DeleteAdmin($id: ID!) {
    deleteAdmin(id: $id) {
      success
      message
    }
  }
`; 